import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AnnotationUtilityService {
    title = 'AnnotationUtilitiesService';
    guidCountMap: {[key: number]: number} = {};

    getAnnotationSetId(guidMap: any, feature: any) {
        var annotationSetId = null;
        if (feature.attributes.attribute10) {
            if (!guidMap[feature.attributes.attribute10]) {
                guidMap[feature.attributes.attribute10] = this.newAnnotationSetGuid();
            }
            annotationSetId = guidMap[feature.attributes.attribute10];
        }
        return annotationSetId;
    }

    newAnnotationSetGuid() {
        var date = new Date();
        var day = date.getDate().toString().length === 2 ? date.getDate() : '0' + date.getDate();
        var month = (date.getMonth() + 1).toString().length === 2 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
        var hours = this.addZero(date.getHours());
        var mins = this.addZero(date.getMinutes());
        var secs = this.addZero(date.getSeconds());
        var millis = this.addZero(date.getMilliseconds());

        const k = day + '-' + month + '-' + date.getFullYear() + '-' + hours + '-' + mins + '-' + secs + '-' + millis;

        if (!this.guidCountMap[k]) {
            this.guidCountMap[k] = 0;
        }

        this.guidCountMap[k]++;

        return `${k}_${this.guidCountMap[k]}`;
    }

    addZero(i: any) {
        console.debug(this.title + ' : addZero');

        if (i < 10) {
            i = '0' + i;
        }
        return i;
    }
}
